import { DEV_MODE } from '../../../global/env';
import { DisposalBin, listen } from '../../events';
import { Logger } from '../../logger';
import { ManagedElementConnectEvent } from './ManagedElement';
export class ElementManager {
    constructor(_host) {
        this._host = _host;
        this._managedElements = new Set();
        /* c8 ignore start */
        if (DEV_MODE) {
            this._logger = new Logger(_host, { owner: this });
        }
        /* c8 ignore stop */
        this._disconnectDisposal = new DisposalBin(_host, 
        /* c8 ignore next */
        DEV_MODE && { name: 'elementManagerDisconnectDisposal', owner: this });
        _host.addController({
            hostConnected: this._handleHostConnected.bind(this),
            hostDisconnected: this._handleHostDisconnected.bind(this)
        });
    }
    static get _ScopedDiscoveryEvent() {
        return ManagedElementConnectEvent;
    }
    _handleHostConnected() {
        const ScopedDiscoveryEvent = this._getScopedDiscoveryEvent();
        this._disconnectDisposal.add(listen(this._host, ScopedDiscoveryEvent.TYPE, this._handleElementConnect.bind(this)));
        /* c8 ignore start */
        if (DEV_MODE) {
            this._logger.debug('started listening');
        }
        /* c8 ignore stop */
    }
    _handleHostDisconnected() {
        this._disconnectDisposal.empty();
        this._removeAllElements();
        /* c8 ignore start */
        if (DEV_MODE) {
            this._logger.debug('disconnected');
        }
        /* c8 ignore stop */
    }
    _handleElementConnect(event) {
        const { element, onDisconnect } = event.detail;
        this._addElement(element);
        onDisconnect(() => {
            this._removeElement(element);
        });
    }
    _getScopedDiscoveryEvent() {
        const ctor = this.constructor;
        const ScopedDiscoveryEvent = ctor._ScopedDiscoveryEvent;
        return ScopedDiscoveryEvent;
    }
    _addElement(element) {
        if (this._managedElements.has(element))
            return;
        this._managedElements.add(element);
        this._handleElementAdded(element);
        /* c8 ignore start */
        if (DEV_MODE) {
            this._logger
                .debugGroup('added element')
                .appendWithLabel('Element', element)
                .end();
        }
        /* c8 ignore stop */
    }
    _handleElementAdded(element) {
        // no-op
    }
    _removeElement(element) {
        if (!this._managedElements.has(element))
            return;
        this._managedElements.delete(element);
        this._handleElementRemoved(element);
        /* c8 ignore start */
        if (DEV_MODE) {
            this._logger
                .debugGroup('removed element')
                .appendWithLabel('Element', element)
                .end();
        }
        /* c8 ignore stop */
    }
    _removeAllElements() {
        this._managedElements.forEach(this._removeElement.bind(this));
    }
    _handleElementRemoved(element) {
        // no-op
    }
}
